import * as React from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  makeStyles,
  TextField,
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { getAllProgramsAsync } from '../Programs/ProgramStore/programStoreSlice';
import { createCourseAsync } from './CourseStore/courseStoreSlice';
import BuzzInput from '../../../components/BuzzInput/BuzzInput';
import BuzzSelect from '../../../components/BuzzSelect/BuzzSelect';
import useToast from '../../../hooks/useToast';
import useLoader from '../../../hooks/useLoader';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
  fontFamily: 'Rubik',
};

const useStyles = makeStyles({
  input: {
    '& input[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '& input[type=number]::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '& input[type=number]::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
});

const AddCourseForm = ({ fetchDefaultData, handleClose }) => {
  const classes = useStyles();
  const [title, setTitle] = React.useState(null);
  const [description, setDescription] = React.useState(null);
  const [price, setPrice] = React.useState(null);
  const [priceInDollar, setPriceInDollar] = React.useState(false);
  const [categoryId, setCategoryId] = React.useState(null);
  const [isPopular, setIsPopular] = React.useState(false);
  const [isFeatured, setIsFeatured] = React.useState(false);

  const { handleLoader } = useLoader();
  const { ErrorToast, SuccessToast } = useToast();

  const dispatch = useDispatch();
  const { programs } = useSelector((state) => {
    const { programReducer } = state;

    return {
      programs: programReducer.programs,
    };
  });

  React.useEffect(() => {
    fetchProgramList();
  }, []);

  const fetchProgramList = async () => {
    try {
      dispatch(getAllProgramsAsync());
    } catch (error) {
      console.log(error);
    }
  };

  const addCourse = async () => {
    try {
      handleLoader(true);
      let payload = {
        title,
        description,
        categoryId,
        price,
        type: 'course',
        metaData: {
          // keywords: ['carrer studies', 'online'],
          // duration: '6 Months',
          // certificate: true,
          priceInDollar: priceInDollar,
          popular: isPopular,
          featured: isFeatured,
        },
      };
      dispatch(createCourseAsync(payload))
        .unwrap()
        .then((res) => {
          if (res) {
            SuccessToast(`Course added successfully.`);
            fetchDefaultData();
            handleLoader(false);
            handleClose();
          } else {
            handleLoader(false);
          }
        });
    } catch (error) {
      handleLoader(false);
      ErrorToast('Course could not be added. Please try again!');
    }
  };

  return (
    <Box sx={style}>
      <Box>
        <Box sx={{ fontSize: 18, fontWeight: 'medium' }}>Add a course</Box>
        <Box alignItems="center">
          <Box my={2}>
            <BuzzInput
              type="text"
              required
              placeholder="Course Title*"
              variant="outlined"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              size="small"
              fullWidth
            />
          </Box>

          <Box my={2}>
            <TextField
              required
              variant="outlined"
              placeholder="Program Description"
              multiline
              rows={2}
              rowsMax={2}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              size="small"
              fullWidth
            />
          </Box>
        </Box>

        <Box my={2}>
          <TextField
            required
            type="number"
            placeholder="Course Price*"
            variant="outlined"
            size="small"
            fullWidth
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className={classes.input}
          />
        </Box>
        <Box my={2}>
          <TextField
            required
            type="number"
            placeholder="Course Price in Dollar*"
            variant="outlined"
            size="small"
            fullWidth
            value={priceInDollar}
            onChange={(e) => setPriceInDollar(e.target.value)}
            className={classes.input}
          />
        </Box>
        <Box my={2}>
          <BuzzSelect
            labelKey="name"
            valueKey="_id"
            options={programs}
            placeholder="Select category*"
            value={categoryId}
            onChange={(e) => setCategoryId(e.target.value)}
          />
        </Box>
        <Box my={2}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={isPopular}
                  onChange={(e) => {
                    setIsPopular(e.target.checked);
                  }}
                />
              }
              label="Is Popular Course ?"
            />
            <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  checked={isFeatured}
                  onChange={(e) => {
                    setIsFeatured(e.target.checked);
                  }}
                />
              }
              label="Is Featured Course ?"
            />
          </FormGroup>
        </Box>
        <Box mt={3} mb={2}>
          <Button variant="contained" color="primary" onClick={addCourse}>
            Add Course
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddCourseForm;
